import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Schedule } from '@/components/Schedule/types';

type GetTripsResponse = {
  state: number;
  value: Schedule[];
};

export const getAssignTrips = async (): Promise<Schedule[]> => {
  try {
    const res = await apiClient.post<GetTripsResponse>(
      Endpoints.AssignTrips,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
